import { PREFIX } from '../../constants';

const generateBoxShadowStyles = ({ controlName, attributes }) => {
    const {
        [`${PREFIX}${controlName}BoxShadowPosition`]: boxShadowPosition = 'outset',
        [`${PREFIX}${controlName}BoxShadowColor`]: boxShadowColor = '',
        [`${PREFIX}${controlName}BoxShadowHorizontal`]: boxShadowHorizontal = 0,
        [`${PREFIX}${controlName}BoxShadowVertical`]: boxShadowVertical = 0,
        [`${PREFIX}${controlName}BoxShadowBlur`]: boxShadowBlur = 0,
        [`${PREFIX}${controlName}BoxShadowSpread`]: boxShadowSpread = 0
    } = attributes;

    // if (!boxShadowColor) return;

    let boxShadowStyles = '';

    // box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2) inset; || box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.2);

    const horizontalUnit = boxShadowHorizontal && boxShadowHorizontal !== 0 ? 'px' : '';
    const verticalUnit = boxShadowVertical && boxShadowVertical !== 0 ? 'px' : '';
    const blurUnit = boxShadowBlur && boxShadowBlur !== 0 ? 'px' : '';
    const spreadUnit = boxShadowSpread && boxShadowSpread !== 0 ? 'px' : '';

    if (boxShadowHorizontal || boxShadowVertical || boxShadowBlur || boxShadowSpread) {
        if (boxShadowPosition === 'inset') {
            boxShadowStyles += `
            box-shadow: ${boxShadowHorizontal}${horizontalUnit} ${boxShadowVertical}${verticalUnit} ${boxShadowBlur}${blurUnit} ${boxShadowSpread}${spreadUnit} ${boxShadowColor} ${boxShadowPosition};
        `;
        } else {
            boxShadowStyles += `
            box-shadow: ${boxShadowHorizontal}${horizontalUnit} ${boxShadowVertical}${verticalUnit} ${boxShadowBlur}${blurUnit} ${boxShadowSpread}${spreadUnit} ${boxShadowColor};
        `;
        }
    }

    return {
        boxShadowStyles
    };
};

export default generateBoxShadowStyles;
